import { DataSource } from '@angular/cdk/collections';
import { merge, Observable, of as observableOf } from 'rxjs';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';


@Injectable()
export class GridDataSource extends DataSource<any> {
  // constructor(public data: any[]) {
  //   super();
  //   this.connect(): Observable<any[]> {
  //     return data;
  //   }

  //   this.disconnect() {}
  // }
  constructor(public data: any[]) {
    super();
  }
  connect(): Observable<any[]> {
    return Observable.of(this.data);
  }
  disconnect() {
  }
}
